import type {CourseVideoResponse} from 'src/api/ProactApiClient';
import type {IFormDataV2, IFormFieldV2} from 'src/types/FormV2';

export const FormErrorText = {
  fieldRequired: 'This field is required.',
  stringAndSpecialChar:
    'Only alphanumeric and standard special characters allowed.',
};

export const CourseVideoFormMeta = (): IFormFieldV2[] => [
  {
    name: 'title',
    label: 'Title',
    type: 'text',
    required: true,
    size: 'xl',
    description:
      'The title of the course video. This is shown in dropdowns and list views.',
  },
  {
    name: 'description',
    label: 'Description',
    type: 'textarea',
    required: false,
    size: 'xl',
    description:
      'The description of the course video. This is shown in management views.',
  },
  {
    name: 'contentUrl',
    label: 'Video File',
    type: 'file',
    required: true,
    size: 'xl',
    description:
      'Upload a video file to be used as the course video. Larger files may take a moment to upload, and they may take longer to load when viewed during training. Videos under 150MB are recommended.',
    validation: {
      maxLength: 10000,
    },
    fileUploadOptions: {
      allowMultiple: false,
      maxFileSize: 300e6, // 300MB
      allowedFileTypes: ['video/*'],
      simplifiedUploader: true,
    },
  },
  {
    name: 'active',
    label: 'Active',
    type: 'switch',
    required: false,
    size: 'xl',
    description:
      'Enable or disable the course video. If enabled, the course video will be available for selection in the course designer. Disabling the course video does not delete the video or remove it from existing training courses. To remove the video from a course, edit the course lesson in the course designer.',
  },
];

export const GetDefaultCourseVideoFormData = (): IFormDataV2 => ({
  title: '',
  description: '',
  contentUrl: '',
  active: true,
});

export const MapCourseVideoResponseToFormData = (
  resp: CourseVideoResponse
): IFormDataV2 => {
  return {
    ...resp,
    title: resp.title ?? '',
    description: resp.description ?? '',
    contentUrl: resp.contentUrl ?? '',
    active: resp.active ?? true,
  };
};

export const courseVideoDocumentTitle = 'Course Video';
